export const getTranslatedGroupName = (t, group) => {
    const TRANSLATED_GROUPS_NAMES = [t("ADMINPANEL.USERS.USER"), t("ADMINPANEL.USERS.ADMIN")];

    if (group?.group_id && group?.name) {
        if (group.group_id === 1) return TRANSLATED_GROUPS_NAMES[0];
        else if (group.group_id === 2) return TRANSLATED_GROUPS_NAMES[1];
        return group.name;
    }
    return TRANSLATED_GROUPS_NAMES[0];
};
